import { Component, OnInit, OnDestroy, Injector, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import { DataService } from "../../services/data/data.service";
import { BoxQuotaData } from "../../model/box.quote.data";
import { MonitorSelectedSymbol } from "../../model/monitor.selected.symbol";
import { monitorPeriodsService, selectedPeriods } from "../../services/monitorPeriods/monitorPeriods.service";
import { dragAndDropSymbol } from "../../services/dragAndDropSymbol/dragAndDropSymbol.service";

import * as $ from "jquery";
import { HistoryItemPeriod } from "../../interfaces/historyItem";
import { SymbolTypeService } from "../../services/quoteFilterTabsActiveMode/quoteFilterTabsActiveMode.service";
import { SymbolTypeEnum } from "../../enums/SymbolType.enum";
import { symbolsForexOrder, getSymbolOrder } from "../../services/data/data.service";
import { AppComponentBase } from "../../services/AppComponentBase";
import { monitorInitialList } from "../../interfaces/quote.data";
import { ChartDisplayMode } from "../../enums/ChartDisplayMode.list";
import { Providers } from "../../enums/providers";
import { QuotePanelsTabsList } from "../../enums/QuotePanelsTabs.list";
@Component({
    selector: "app-quotes-monitor",
    template: require('./quotes-monitor.component.html'),
    styles: [require('./quotes-monitor.component.scss')]
})
export class QuotesMonitorComponent extends AppComponentBase implements OnInit, OnDestroy, AfterViewInit {
    public selectedSymbols: string[] = [];
    public selectedSymbolsData: { [id: string]: MonitorSelectedSymbol } = {};
    @ViewChild("monitor") monitorContainer!: ElementRef;

    get monitorWidth() {
        if (this.monitorContainer) {
            return this.monitorContainer.nativeElement.offsetWidth;
        } else {
            return 0;
        }
    }

    public get currentBasket() {
        return this.workspace.activeBasket;
    }

    public get currentType() {
        return this.workspace.activeSymbolType;
    }

    public get canShowMonitor() {
        return this.workspace.activeTab == QuotePanelsTabsList.MONITOR;
    }

    constructor(
        injector: Injector,
        public monitorPeriodsService: monitorPeriodsService,
        private dragAndDropSymbol: dragAndDropSymbol
    ) {
        super(injector);

        this.workspace.globaGridMode.refreshProviderSignal.subscribe(v => {
            this.selectedSymbols = [];
            this.selectedSymbolsData = {};

            this.runFilteredPeriods();

            this.globaGridMode.changeActiveBasket.next(this.currentBasket);
        });

        this.runMonitorSubscribers(monitorPeriodsService);
    }

    public runMonitorSubscribers(monitorPeriodsService: monitorPeriodsService) {
        this.selectedSymbols = Object.keys(this.selectedSymbolsData);

        this.symbolTypeService.subscriber.subscribe(type => {
            if (this.currentBasket == -1) {
                this.runStandardSymbols(type, this.dataService, monitorPeriodsService);
            }
        });

        this.globaGridMode.changeActiveBasket.subscribe(v => {
            if (this.workspace.activeTab != QuotePanelsTabsList.MONITOR) return;
            this.selectedSymbols = [];
            if (v != -1) {
                let symbols: string[] = this.workspace.getBasketItems(v);
                symbols.forEach(s => {
                    this.selectedSymbolsData[s] =
                        this.selectedSymbolsData[s] ||
                        new MonitorSelectedSymbol(
                            this.dataService,
                            this.workspace,
                            s,
                            100,
                            monitorPeriodsService,
                            this.wakeUp
                        );
                    this.selectedSymbolsData[s].enableBuyAndSell = false;
                });
                this.selectedSymbols = symbols.filter(l => {
                    if (
                        this.workspace.competitionAccountList.indexOf(this.workspace.activeAccountIdBySet) > -1 ||
                        this.workspace.currentProvider != Providers.DEMO
                    ) {
                        // console.log(this.workspace.currentTournaments[0].tournamentAssets);
                        if (this.workspace.allowedForexSymbols.indexOf(l) > -1) {
                            //&& this.workspace.currentTournaments[0].tournamentAssets.Assets.indexOf(0))
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                });
            } else {
                this.runStandardSymbols(this.workspace.activeSymbolType, this.dataService, monitorPeriodsService);
            }
        });

        this.globaGridMode.longSymbolPeriod.subscribe(t => {
            this.runNewEntryPeriod(t, "long");
        });

        this.globaGridMode.midSymbolPeriod.subscribe(t => {
            this.runNewEntryPeriod(t, "mid");
        });

        this.globaGridMode.shortSymbolPeriod.subscribe(t => {
            this.runNewEntryPeriod(t, "short");
        });

        this.globaGridMode.entrySymbolPeriod.subscribe(t => {
            this.runNewEntryPeriod(t, "entry");
        });
    }

    public runStandardSymbols(
        type: SymbolTypeEnum,
        dataService: DataService,
        monitorPeriodsService: monitorPeriodsService
    ) {
        this.selectedSymbols = [];

        let symbols: string[] = [];

        switch (type) {
            case SymbolTypeEnum.Forex:
                symbols = this.initialMonitorSymbolList;
                break;

            case SymbolTypeEnum.Crypto:
                symbols = this.initialMonitorCryptoSymbolList;
                break;

            case SymbolTypeEnum.Equity:
                symbols = this.initialMonitorEquitiesSymbolList;
                break;

            case SymbolTypeEnum.Commodity:
                symbols = this.initialMonitorCommoditiesSymbolList;
                break;

            case SymbolTypeEnum.Index:
                symbols = this.initialMonitorIndexSymbolList;
                break;

            case SymbolTypeEnum.Bonds:
                symbols = this.initialMonitorBondsSymbolList;
                break;
        }

        symbols.forEach(s => {
            this.selectedSymbolsData[s] =
                this.selectedSymbolsData[s] ||
                new MonitorSelectedSymbol(dataService, this.workspace, s, 100, monitorPeriodsService, this.wakeUp);
            this.selectedSymbolsData[s].enableBuyAndSell = false;
        });

        if (
            this.workspace.competitionAccountList.indexOf(this.workspace.activeAccountIdBySet) > -1 ||
            this.workspace.currentProvider != Providers.DEMO
        ) {
            if (this.workspace.allowedForexSymbols.length == 0) {
                setTimeout(() => {
                    console.log("this.workspace.allowedForexSymbols");
                    console.log(this.workspace.allowedForexSymbols);
                    this.runStandardSymbols(this.workspace.activeSymbolType, this.dataService, monitorPeriodsService);
                }, 500);
                //  debugger;
            } else {
                //    debugger
                this.selectedSymbols = symbols.filter(l => {
                    if (
                        this.workspace.competitionAccountList.indexOf(this.workspace.activeAccountIdBySet) > -1 ||
                        this.workspace.currentProvider != Providers.DEMO
                    ) {
                        // console.log(this.workspace.currentTournaments[0].tournamentAssets);
                        //   debugger
                        if (this.workspace.allowedForexSymbols.indexOf(l) > -1) {
                            //&& this.workspace.currentTournaments[0].tournamentAssets.Assets.indexOf(0))
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                });
            }
        } else {
            this.selectedSymbols = symbols;
        }
    }

    private boxesLimit: number = 6;
    public get visibleBoxes() {
        let standardVisible = this.workspace.boxes.filter(b => b.visible && b.searchVisible);
        let type = this.workspace.activeSymbolType;
        if (standardVisible.length < this.boxesLimit) {
            let notInStandardVisible = this.workspace.boxes
                .filter(item => standardVisible.indexOf(item) === -1 && item.Type == type)
                .slice(0, this.boxesLimit - standardVisible.length);
            let merge = standardVisible.concat(notInStandardVisible);
            return merge; //.sort((a, b) => this.getSymbolOrder(a.Symbol)-this.getSymbolOrder(b.Symbol));//.slice(0, this.boxesLimit);
        } else {
            return standardVisible
                .sort((a, b) => this.getSymbolOrder(a.Symbol) - this.getSymbolOrder(b.Symbol))
                .slice(0, this.boxesLimit);
        }
    }

    public getItemsBySymbolType(type: SymbolTypeEnum, limit: number) {
        let visible = this.workspace.boxes.filter(b => b.visible && b.searchVisible);
        let symbolList = visible.filter(item => item.Type == type);

        return symbolList
            .sort((a, b) => this.getSymbolOrder(a.Symbol) - this.getSymbolOrder(b.Symbol))
            .slice(0, limit)
            .map(j => {
                return j.Symbol;
            });
    }

    public get initialMonitorSymbolList() {
        return monitorInitialList;
    }

    public get initialMonitorBondsSymbolList() {
        return this.getItemsBySymbolType(SymbolTypeEnum.Bonds, 10000);
    }

    public get initialMonitorCryptoSymbolList() {
        return this.getItemsBySymbolType(SymbolTypeEnum.Crypto, 10000);
    }

    public get initialMonitorEquitiesSymbolList() {
        return this.getItemsBySymbolType(SymbolTypeEnum.Equity, 20);
    }

    public get initialMonitorIndexSymbolList() {
        return this.getItemsBySymbolType(SymbolTypeEnum.Index, 10);
    }

    public get initialMonitorCommoditiesSymbolList() {
        return this.getItemsBySymbolType(SymbolTypeEnum.Commodity, 20);
    }

    private _symbolsOrder: string[] = symbolsForexOrder;
    private getSymbolOrder(symbol: string) {
        return getSymbolOrder(symbol, this._symbolsOrder);
    }

    public async runNewEntryPeriod(v: HistoryItemPeriod, type: string) {
        let selectedSymbols = this.workspace.boxes.map(b => b.Symbol);
        selectedSymbols.forEach(s => {
            if (this.selectedSymbolsData[s]) {
                switch (type) {
                    case "long":
                        this.selectedSymbolsData[s].setNewLongperiod(v);
                        break;

                    case "mid":
                        this.selectedSymbolsData[s].setNewMidperiod(v);
                        break;

                    case "short":
                        this.selectedSymbolsData[s].setNewShortperiod(v);
                        break;

                    case "entry":
                        this.selectedSymbolsData[s].setNewEntryperiod(v);
                        break;
                }
            }
        });
    }

    public async runFilteredPeriods() {
        this.workspace.charts.ach1.Period[ChartDisplayMode.ENTSIGNALS] = this.workspace.getCorrectPeriod(
            this.workspace.charts.ach1.Period[ChartDisplayMode.ENTSIGNALS]
        );
        this.workspace.globaGridMode.longSymbolPeriod.next(
            this.workspace.charts.ach1.Period[ChartDisplayMode.ENTSIGNALS]
        );

        this.workspace.charts.ach2.Period[ChartDisplayMode.ENTSIGNALS] = this.workspace.getCorrectPeriod(
            this.workspace.charts.ach2.Period[ChartDisplayMode.ENTSIGNALS]
        );
        this.workspace.globaGridMode.midSymbolPeriod.next(
            this.workspace.charts.ach2.Period[ChartDisplayMode.ENTSIGNALS]
        );

        this.workspace.charts.ach3.Period[ChartDisplayMode.ENTSIGNALS] = this.workspace.getCorrectPeriod(
            this.workspace.charts.ach3.Period[ChartDisplayMode.ENTSIGNALS]
        );
        this.workspace.globaGridMode.shortSymbolPeriod.next(
            this.workspace.charts.ach3.Period[ChartDisplayMode.ENTSIGNALS]
        );

        this.workspace.charts.ach4.Period[ChartDisplayMode.ENTSIGNALS] = this.workspace.getCorrectPeriod(
            this.workspace.charts.ach4.Period[ChartDisplayMode.ENTSIGNALS]
        );
        this.workspace.globaGridMode.entrySymbolPeriod.next(
            this.workspace.charts.ach4.Period[ChartDisplayMode.ENTSIGNALS]
        );
    }

    dragStart(item: any): void {
        this.dragAndDropSymbol.subscriber.next(this.selectedSymbolsData[item].Symbol);
    }

    ngOnDestroy(): void {
        this.dragAndDropSymbol.subscriber.unsubscribe();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            $(".monitor-container").mCustomScrollbar({
                axis: "y",
                theme: "inset-3", // "minimal-dark",
                scrollbarPosition: "outside",
                alwaysShowScrollbar: 0, // 0,1,2
                scrollButtons: {
                    enable: true
                },
                mouseWheel: {
                    enable: true
                    //  scrollAmount: 5
                }
            });
        }, 100);
    }

    ngOnInit() {}

    public removeSymbolFromBasket(symbol: string) {
        this.workspace.removeFromBasket(this.activeBasket, symbol);
    }

    set activeBasket(v: number) {
        this.workspace.activeBasket = v;
    }

    get activeBasket() {
        return this.workspace.activeBasket;
    }

    public formatQuote(v: number, decimal: number) {
        return v.toFixed(decimal);
    }
}
